import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-checked", "aria-busy", "disabled", "data-testid"]

import { computed, useSlots } from 'vue'

export type SwitchSize = 'small' | 'medium'

const outerClasses =
  'flex items-center justify-center rounded-full bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: { type: Boolean },
    label: { default: undefined },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    size: { default: 'medium' },
    dataTestid: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const slots = useSlots()

const isInteractive = computed(() => !props.disabled && !props.loading)
const hasLabel = computed(() => !!props.label || !!slots.default)

function toggle() {
  if (!isInteractive.value) return
  emit('update:modelValue', !props.modelValue)
}

const SIZE_CONFIG: Record<
  SwitchSize,
  { outer: string; track: string; thumb: string; label: string }
> = {
  small: {
    outer: 'w-[38px] h-[22px] p-[3px]',
    track: 'w-full h-full p-[2px]',
    thumb: 'w-3 h-3',
    label: 'text-xs'
  },
  medium: {
    outer: 'w-[50px] h-[30px] p-[3px]',
    track: 'w-full h-full p-[3px]',
    thumb: 'w-[18px] h-[18px]',
    label: 'text-sm'
  }
}

const sizeConfig = SIZE_CONFIG[props.size]

const trackClasses = computed(() => [
  'relative inline-flex items-center rounded-full transition-colors duration-200',
  props.modelValue
    ? props.disabled
      ? 'bg-primary30/40'
      : 'bg-primary30'
    : props.disabled
      ? 'bg-lightGray30/60'
      : 'bg-lightGray30'
])

const thumbClasses = computed(() => [
  'rounded-full bg-white shadow-sm transition-transform duration-200',
  props.loading ? 'animate-pulse' : '',
  props.modelValue
    ? props.size === 'small'
      ? 'translate-x-[16px]'
      : 'translate-x-[20px]'
    : 'translate-x-0'
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([
      'inline-flex items-center gap-2 select-none',
      isInteractive.value ? 'cursor-pointer' : 'cursor-not-allowed'
    ])
  }, [
    _createElementVNode("button", {
      type: "button",
      role: "switch",
      "aria-checked": _ctx.modelValue,
      "aria-busy": _ctx.loading,
      disabled: _ctx.disabled || _ctx.loading,
      class: _normalizeClass([outerClasses, _unref(sizeConfig).outer]),
      "data-testid": _ctx.dataTestid || 'toggle-switch-track',
      onClick: toggle
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([trackClasses.value, _unref(sizeConfig).track])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([thumbClasses.value, _unref(sizeConfig).thumb])
        }, null, 2)
      ], 2)
    ], 10, _hoisted_1),
    (hasLabel.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['font-medium', _unref(sizeConfig).label, _ctx.disabled ? 'text-gray-400' : 'text-textPrimary'])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})